(() => {
  const roots = document.querySelectorAll('[data-orelvon-home-search]');

  const safeSameOriginUrl = (value) => {
    try {
      const url = new URL(String(value || ''), window.location.origin);
      return url.origin === window.location.origin ? url : null;
    } catch (_error) {
      return null;
    }
  };

  const safeImageUrl = (value) => {
    const raw = typeof value === 'object' && value ? value.url : value;
    try {
      const url = new URL(String(raw || ''), window.location.origin);
      return url.protocol === 'https:' || url.origin === window.location.origin ? url.toString() : '';
    } catch (_error) {
      return '';
    }
  };

  roots.forEach((root) => {
    const form = root.querySelector('[data-home-search-form]');
    const input = root.querySelector('[data-home-search-input]');
    const results = root.querySelector('[data-home-search-results]');
    const endpoint = safeSameOriginUrl(root.dataset.predictiveSearchUrl || '/search/suggest');
    const searchRoute = safeSameOriginUrl(root.dataset.searchUrl || '/search');

    if (!form || !input || !results || !endpoint || !searchRoute) return;

    let timer = 0;
    let controller = null;

    const closeResults = () => {
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    };

    const openResults = () => {
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    const createMessage = (message) => {
      const item = document.createElement('div');
      item.className = 'orelvon-home-search__message';
      item.textContent = message;
      return item;
    };

    const createResult = (product) => {
      const productUrl = safeSameOriginUrl(product.url);
      if (!productUrl) return null;

      const link = document.createElement('a');
      link.className = 'orelvon-home-search__result';
      link.href = productUrl.toString();

      const imageUrl = safeImageUrl(product.image);
      if (imageUrl) {
        const image = document.createElement('img');
        image.className = 'orelvon-home-search__result-image';
        image.src = imageUrl;
        image.alt = '';
        image.width = 58;
        image.height = 58;
        image.loading = 'lazy';
        link.appendChild(image);
      } else {
        const imagePlaceholder = document.createElement('span');
        imagePlaceholder.className = 'orelvon-home-search__result-image';
        imagePlaceholder.setAttribute('aria-hidden', 'true');
        link.appendChild(imagePlaceholder);
      }

      const copy = document.createElement('span');
      copy.className = 'orelvon-home-search__result-copy';

      const title = document.createElement('span');
      title.className = 'orelvon-home-search__result-title';
      title.textContent = String(product.title || 'Lighting');
      copy.appendChild(title);

      if (product.price) {
        const price = document.createElement('span');
        price.className = 'orelvon-home-search__result-price';
        price.textContent = String(product.price);
        copy.appendChild(price);
      }

      const arrow = document.createElement('span');
      arrow.className = 'orelvon-home-search__result-arrow';
      arrow.textContent = '→';
      arrow.setAttribute('aria-hidden', 'true');

      link.append(copy, arrow);
      return link;
    };

    const renderProducts = (products, query) => {
      const fragment = document.createDocumentFragment();

      if (!products.length) {
        fragment.appendChild(createMessage(`No products found for “${query}”`));
      } else {
        products.slice(0, 5).forEach((product) => {
          const item = createResult(product);
          if (item) fragment.appendChild(item);
        });

        const viewAllUrl = new URL(searchRoute.toString());
        viewAllUrl.searchParams.set('q', query);
        viewAllUrl.searchParams.set('type', 'product');

        const viewAll = document.createElement('a');
        viewAll.className = 'orelvon-home-search__view-all';
        viewAll.href = viewAllUrl.toString();
        viewAll.textContent = 'View all search results →';
        fragment.appendChild(viewAll);
      }

      results.replaceChildren(fragment);
      openResults();
    };

    const loadResults = async (query) => {
      if (controller) controller.abort();
      controller = new AbortController();

      const url = new URL(endpoint.toString());
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '5');
      url.searchParams.set('resources[options][unavailable_products]', 'last');

      try {
        const response = await fetch(url.toString(), {
          headers: { Accept: 'application/json' },
          signal: controller.signal,
        });
        if (!response.ok) throw new Error(`Search request failed: ${response.status}`);

        const payload = await response.json();
        const products = payload?.resources?.results?.products;
        renderProducts(Array.isArray(products) ? products : [], query);
      } catch (error) {
        if (error.name === 'AbortError') return;
        results.replaceChildren(createMessage('Search is temporarily unavailable. Press Enter to continue.'));
        openResults();
      }
    };

    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      const query = input.value.trim();

      if (query.length < 2) {
        if (controller) controller.abort();
        results.replaceChildren();
        closeResults();
        return;
      }

      timer = window.setTimeout(() => loadResults(query), 180);
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeResults();
        input.blur();
      }
    });

    document.addEventListener('click', (event) => {
      if (!form.contains(event.target)) closeResults();
    });
  });
})();

